export const uploadFile = async (file) => {
    if (!file) return null;

    try {
        const startUpload = async (file) => {
            // 1. Get Pre-signed URL
            const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/upload/presign`;
            const authToken = localStorage.getItem("authToken");

            const presignResponse = await fetch(API_ENDPOINT, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({
                    filename: file.name,
                    contentType: file.type,
                    prefix: "admin-uploads", // Optional: organize uploads
                }),
            });

            if (!presignResponse.ok) {
                const errorData = await presignResponse.json();
                throw new Error(errorData.message || "Failed to get upload URL");
            }

            const { upload } = await presignResponse.json();
            const { uploadUrl, url: publicUrl } = upload;

            // 2. Upload to S3
            const uploadResponse = await fetch(uploadUrl, {
                method: "PUT",
                headers: {
                    "Content-Type": file.type,
                },
                body: file,
            });

            if (!uploadResponse.ok) {
                throw new Error("Failed to upload file to storage");
            }

            return publicUrl;
        };

        return await startUpload(file);
    } catch (error) {
        console.error("Upload Service Error:", error);
        throw error;
    }
};
